module.exports = __webpack_public_path__ + "static/img/cm.3e2c5b4b.svg";